export const SELECTION_STORAGE_PREFIX = "table-interactions-selection"

export default class TableSelectionStore {
  constructor({ storageKey = null, legacyStorageKey = null, scopeFingerprint, storageObject = window.sessionStorage }) {
    this.storageKey = storageKey
    this.legacyStorageKey = legacyStorageKey
    this.scopeFingerprint = scopeFingerprint
    this.storage = storageObject
  }

  discardLegacy() {
    if (!this.legacyStorageKey) return
    try {
      this.storage.removeItem(`${SELECTION_STORAGE_PREFIX}:${this.legacyStorageKey}`)
    } catch (_error) {
      // The scoped key still prevents legacy selections from being read.
    }
  }

  load() {
    const key = this.#key()
    if (!key) return {}
    try {
      const parsed = JSON.parse(this.storage.getItem(key) || "{}")
      if (!(parsed && typeof parsed === "object") || parsed.scope !== this.scopeFingerprint) return {}
      return parsed.records && typeof parsed.records === "object" ? parsed.records : {}
    } catch (_error) {
      return {}
    }
  }

  persist(records) {
    const key = this.#key()
    if (!key) return
    try {
      if (Object.keys(records).length === 0) {
        this.storage.removeItem(key)
      } else {
        this.storage.setItem(key, JSON.stringify({ scope: this.scopeFingerprint, records }))
      }
    } catch (_error) {
      // Keep selection in memory when storage is unavailable.
    }
  }

  #key() {
    return this.storageKey ? `${SELECTION_STORAGE_PREFIX}:${this.storageKey}` : null
  }
}
